module.exports = __webpack_public_path__ + "img/agripreneur.f38b8a03.png";